import {
  BRAND_REFRESH_NAV_TOUR_SPOTLIGHT_KEY,
  SCHEDULING_PAGE_TOUR_SPOTLIGHT_KEY,
} from 'shared/constants/spotlights'

import { BRAND_REFRESH_NAV_TOUR_FORCE_SHOW_PARAM } from '../main_nav/spotlight_tour/constants'

export const SPOTLIGHT_TOUR_DEBUG_IDS = {
  BRAND_REFRESH_NAV: 'brand-refresh-nav',
  SCHEDULING_PAGE: 'scheduling-page',
} as const

export type SpotlightTourDebugId =
  (typeof SPOTLIGHT_TOUR_DEBUG_IDS)[keyof typeof SPOTLIGHT_TOUR_DEBUG_IDS]

type SpotlightTourDebugAction = 'reset' | 'dismiss'

type SpotlightTourDebugConfig = {
  spotlightKey: string
  forceShowParam: string
  reloadHint: string
  activeTourWarning?: boolean
  actions: readonly SpotlightTourDebugAction[]
  resetTestId: string
  dismissTestId?: string
  resetLabel?: string
}

/** Debug-panel metadata for backend-persisted spotlight tours registered via `*.debug.tsx`. */
export const SPOTLIGHT_TOUR_DEBUG_CONFIG: Record<SpotlightTourDebugId, SpotlightTourDebugConfig> = {
  [SPOTLIGHT_TOUR_DEBUG_IDS.BRAND_REFRESH_NAV]: {
    spotlightKey: BRAND_REFRESH_NAV_TOUR_SPOTLIGHT_KEY,
    forceShowParam: BRAND_REFRESH_NAV_TOUR_FORCE_SHOW_PARAM,
    reloadHint: 'Reload the page afterward to replay it.',
    activeTourWarning: true,
    actions: ['reset', 'dismiss'],
    resetTestId: 'brand-refresh-debug-tour-reset',
    dismissTestId: 'brand-refresh-debug-tour-dismiss',
  },
  [SPOTLIGHT_TOUR_DEBUG_IDS.SCHEDULING_PAGE]: {
    spotlightKey: SCHEDULING_PAGE_TOUR_SPOTLIGHT_KEY,
    // Matches `SCHEDULING_PAGE_TOUR_FORCE_SHOW_PARAM` in use_scheduling_page_tour_state.js
    forceShowParam: 'show_scheduling_tour',
    reloadHint: 'Reload the scheduling page afterward to replay it.',
    actions: ['reset'],
    resetTestId: 'brand-refresh-debug-scheduling-tour-reset',
    resetLabel: 'Clear tour',
  },
}
